import { useContext, useRef } from 'react';
import ConfirmationContext from './ConfirmationContext';

const useConfirmaion = () => { 
    const confirmationRef = useRef();
    const context = useContext(ConfirmationContext);
    confirmationRef.current = context;
    return confirmationRef.current;
}

export default useConfirmaion;